import { createSubscriptionHook } from '~/shared/providers/api';

export const useLoadChangesSubscription = createSubscriptionHook(
  'trade.loadChanges',
  (params: { ids: string[] }) => ({
    tradeLoadChanges: {
      __args: { ids: params.ids },
      id: true,
      version: true,
    },
  }),
  {
    select: ({ tradeLoadChanges }) => tradeLoadChanges,
  },
);
